import { type ApproverDelegateeConstructor } from '@webapp/core/entities/internal/ApproverDelegatee'
import { type ApproverDelegateeApiModel } from '../api-models/ApproverDelegateeApiModel'

export const mapApproverDelegatee = (
  delegatee: ApproverDelegateeApiModel
): ApproverDelegateeConstructor => ({
  id: delegatee.id,
  firstName: delegatee.firstName,
  lastName: delegatee.lastName,
  expectedReturnDate: delegatee.expected_return_date || null,
})
